import React, { useEffect, useState, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";


const HourlyBranchPerformanceReport = ({ openHourlyBranchPerformanceReport, dateFrom, dateTo, selectedRegionIds, changeRegionIds, reportUrl }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [allreportsNew, setAllReportsNew] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const timeoutRef = useRef(null);


    const [dataTable, setDataTable] = useState({
        page: 0,
        size: 10,
        search: '',
        order: null,
    });

    const setTable = (tableState) => {
        setDataTable({
            page: tableState.page,
            search: tableState.searchText,
            size: tableState.rowsPerPage,
            order: tableState.sortOrder
        });
    };

    const columns = [

        {
            label: 'Branch',
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: 'Date',
            name: 'issuedDate',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px' }}>{value}</p>
                )
            }
        },
        {
            label: 'Hour',
            name: 'hours',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px' }}>{value}</p>
                )
            }
        },
        {
            label: 'Tickets Issued + Transferred ',
            name: 'ticketCount',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Tickets Served",
            name: 'servedTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: " Within Target Wait Time",
            name: 'withinAcceptWaitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "After Target Wait Time",
            name: 'afterTargetWaitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Pending Tickets",
            name: 'pendingTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Waiting Tickets",
            name: 'waitingTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Serving Tickets",
            name: 'servingTickets',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Max Service Time",
            name: 'maxServiceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Max Wait Time",
            name: 'maxWaitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Avg Service Time",
            name: 'averageServiceTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Avg Wait Time",
            name: 'averageWaitingTime',
            options: {
                sort: true,
                filter: false,
            }
        },


    ];

    const options = {
        // tableBodyHeight: '80vh',
        filterType: 'dropdown',
        filter: false,
        responsive: 'vertical',
        serverSide: true,
        count: count,
        download: false,
        jumpToPage: true,
        selectableRows: 'none',
        storageKey: '_br_hbpr_table',
        print: false,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        onTableChange: (action, tableState) => {

            // a developer could react to change on an action basis or
            // examine the state as a whole and do whatever they want

            switch (action) {
                case 'changePage':
                    getHourlyBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'sort':
                    getHourlyBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    getHourlyBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'search':
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(() => getHourlyBranchPerformanceReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage), 2000);
                    setTable(tableState);
                    break;
                default:
                    break;
            }
        },
    };



    // when pick date, call  getHourlyBranchPerformanceReport function
    useEffect(() => {
        if (openHourlyBranchPerformanceReport) {
            if (dateFrom.length > 0 && dateTo.length > 0) {
                getHourlyBranchPerformanceReport(0, null, null, rowsPerPage);
            }
        }
    }, [openHourlyBranchPerformanceReport, dateFrom, dateTo])

    // when change selected region array, call getHourlyBranchPerformanceReport - useEffect
    useEffect(() => {
        if (openHourlyBranchPerformanceReport) {
            getHourlyBranchPerformanceReport(0, null, null, rowsPerPage);
        }
    }, [changeRegionIds])


    // getHourlyBranchPerformanceReport - function
    const getHourlyBranchPerformanceReport = (page, sortOrder, search, size) => {
        setIsLoading(true);

        axios({
            method: 'POST',
            url: `${reportUrl}/report-controller/get/hourly-branch-performance-data/paginated/customer/${userDetails.cid}`,
            headers: {
                Authorization: token
            },
            data: {
                "page": page,
                "size": size,
                "dateFrom": dateFrom,
                "dateTo": dateTo,
                "sort": sortOrder,
                "searchText": search,
                branchIds: selectedRegionIds
            }

        }).then((res) => {

            let data = res.data.data;

            setAllReportsNew((data.content))
            setCount(data.totalElements);
            setIsLoading(false);

        }).catch((error) => {
            console.log(error);
            setIsLoading(false);

            if (error.response !== undefined) {
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }


    return (
        <>
            <div><ToastContainer /></div>

            <MUIDataTable
                title={
                    <>
                        {isLoading ?
                            <CircularProgress color="secondary" size={20} /> : <>{count} records.</>}
                    </>
                }
                data={allreportsNew}
                columns={columns}
                options={options}
                className='text-center-table'
            />

        </>
    )
}

export default HourlyBranchPerformanceReport
